/**
 * 将 basicFields 转为行布局，使「出库单」类模板（1 个左字段 + 多个右字段）与模板管理预览一致。
 * 无 colSpan/lineBreakBefore 时：仅当「左侧连续且恰好 1 个左字段 + 随后至少 1 个右字段」时做左右分栏，否则多左+多右会逐行全宽（对账单上易出现「币种下移」）。
 * 有 colSpan 时走 12 格栅格：可显式将编号/日期/币种等同排 (如 4+4+4)，见 default 对账单模板的 basicFields。
 */
export function buildBasicFieldLayoutRows (fields) {
  if (!fields || !fields.length) return []

  const hasGridConfig = fields.some((f) =>
    Object.prototype.hasOwnProperty.call(f || {}, 'colSpan') ||
    Object.prototype.hasOwnProperty.call(f || {}, 'lineBreakBefore')
  )

  if (hasGridConfig) {
    const rows = []
    let currentRow = []
    let currentSpan = 0

    const flushRow = () => {
      if (currentRow.length) {
        rows.push({ type: 'grid', fields: currentRow })
        currentRow = []
        currentSpan = 0
      }
    }

    fields.forEach((field) => {
      const span = Math.max(1, Math.min(12, Number(field?.colSpan || 12)))
      const lineBreakBefore = Boolean(field?.lineBreakBefore)

      if (lineBreakBefore) {
        flushRow()
      }
      if (currentSpan + span > 12) {
        flushRow()
      }

      currentRow.push({ ...field, __colSpan: span })
      currentSpan += span

      if (currentSpan >= 12) {
        flushRow()
      }
    })

    flushRow()
    return rows
  }

  const rows = []
  let i = 0
  while (i < fields.length) {
    const align = fields[i].align || 'left'
    if (align === 'right') {
      const chunk = []
      while (i < fields.length && (fields[i].align || 'left') === 'right') {
        chunk.push(fields[i])
        i++
      }
      chunk.forEach((f) => rows.push({ type: 'full', fields: [f] }))
      continue
    }
    const lefts = []
    while (i < fields.length && (fields[i].align || 'left') !== 'right') {
      lefts.push(fields[i])
      i++
    }
    const rights = []
    while (i < fields.length && (fields[i].align || 'left') === 'right') {
      rights.push(fields[i])
      i++
    }
    if (lefts.length === 1 && rights.length >= 1) {
      rows.push({ type: 'split', left: lefts, right: rights })
    } else {
      lefts.forEach((f) => rows.push({ type: 'full', fields: [f] }))
      rights.forEach((f) => rows.push({ type: 'full', fields: [f] }))
    }
  }
  return rows
}
